import { Modal, ModalFuncProps } from 'antd';
import { NotificationInstance } from 'antd/es/notification/interface';

let notify: NotificationInstance | null = null;

let confirmFn: ((props: ModalFuncProps) => void) | null = null;

export const setConfirmModal = (confirm: typeof Modal.confirm) => {
  confirmFn = confirm;
};

export const showConfirm = (props: ModalFuncProps) => {
  confirmFn?.(props);
};

export const setNotificationApi = (api: any) => {
  notify = api;
};

export const notifySuccess = (description?: string) => {
  notify?.success({ message: 'Амжилттай!', description });
};

export const notifySuccessTitle = (title: string, description?: string) => {
  notify?.success({ message: title, description });
};

export const notifyError = (description?: string) => {
  notify?.error({ message: 'Алдаа!', description });
};

export const priceFormat = (x: number) => {
  if (x || x === 0) {
    let parts = x.toString().split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '');
  } else {
    return null;
  }
};
